import {EMBEDDED_HYBRID, MINI_ORBIT} from '../../css-global-classes';

export class CssRule {
    static get For(): CssRule {
        return new CssRule()
    }
    private _rules: string[] = [];
    private negateNextRule: boolean = false;
    private formatRule(rule: string) {
        if (this.negateNextRule) {
            this.negateNextRule = false;
            return `:not(${rule})`;
        }
        return rule;
    }
    get not(): CssRule {
        this.negateNextRule = true
        return this;
    }
    get desktop(): CssRule {
        this._rules.push(this.formatRule('.cgp-pc'));
        return this;
    }

    get ipad(): CssRule {
        this._rules.push(this.formatRule('.cgp-ipad-device'));
        return this;
    }

    get mobile(): CssRule {
        this._rules.push(this.formatRule('.cgp-mobile'));
        return this;
    }

    get notMobileOs(): CssRule {
        this._rules.push(this.formatRule('.cgp-not-mobile-os'));
        return this;
    }

    get lowRes(): CssRule {
        this._rules.push(this.formatRule('.cgp-low-resolution'));
        return this;
    }

    get portrait(): CssRule {
        this._rules.push(this.formatRule('.cgp-portrait'));
        return this;
    }

    get landscape(): CssRule {
        this._rules.push(this.formatRule('.cgp-landscape'));
        return this;
    }

    get tablet(): CssRule {
        this._rules.push(this.formatRule('.cgp-tablet'));
        return this;
    }

    get RTL(): CssRule {
        this._rules.push(this.formatRule('.cgp-rtl'));
        return this;
    }

    get embededHybrid(): CssRule {
        this._rules.push(this.formatRule(`.${EMBEDDED_HYBRID}`));
        return this;
    }

    get iPhoneVer5(): CssRule {
        this._rules.push(this.formatRule('.cgp-iphone-ver-5'));
        return this;
    }

    get iPhoneVer10(): CssRule {
        this._rules.push(this.formatRule('.cgp-iphone-ver-10'));
        return this;
    }

    get realMobile(): CssRule {
        this._rules.push(this.formatRule('.cgp-real-mobile'));
        return this;
    }

    get miniOrbit(): CssRule {
        this._rules.push(this.formatRule(`.${MINI_ORBIT}`));
        return this;
    }

    build(): string {
        if(this._rules.length === 0) {
            return '';
        }

        return `html${this._rules.join('')}`;
    }
}
